import { msg } from '@lingui/core/macro'
import { createFileRoute } from '@tanstack/react-router'
import { TaskDetail } from '~/components/tasks/task-detail'
import { titleFor } from '~/lib/route-title'
import type { Id } from '~convex/_generated/dataModel'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/tasks/$taskId')({
  component: TaskDetailRoute,
  head: () => ({ meta: [{ title: titleFor(msg`Task`) }] }),
})

function TaskDetailRoute() {
  const { taskId } = Route.useParams()

  return <TaskDetail id={taskId as Id<'tasks'>} key={taskId} />
}
